export default "__VITE_ASSET__C$TqEcp___"